/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {TranslateStore as ɵa} from './src/translate.store';


// WEBPACK FOOTER //
// ~/@ngx-translate/core/core.ts